import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Stack, Switch, Tooltip, Typography } from '@mui/material';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useSearchContext } from '../SearchContextProvider';

export const SearchAiSwitch = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SearchDialog' });

  const { aiSearchIsEnabled, setAiSearchIsEnabled } = useSearchContext();

  const handleAiSwitchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAiSearchIsEnabled(event.target.checked);
  };

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography sx={{ whiteSpace: 'nowrap' }}>{t('aiToggle.title')}</Typography>
      <Tooltip title={t('aiToggle.tooltip')}>
        <InfoOutlinedIcon />
      </Tooltip>
      <Switch checked={aiSearchIsEnabled} onChange={handleAiSwitchChange} />
    </Stack>
  );
};
